export interface SprintUserCommitment {
  estimated: number;
  fixed: number;
  epics: number;
  reviews: number;
  closed: number;
}

export function SprintUserCommitmentFromJSON(
  json: Record<string, any>,
): SprintUserCommitment {
  return {
    estimated: json["estimated"],
    fixed: json["fixed"],
    epics: json["epics"],
    reviews: json["reviews"],
    closed: json["closed"],
  };
}
